import { cn } from "@/lib/utils";

interface SvgMaskIconProps {
  /** /public altındaki SVG yolu, örn: "/anasayfa.svg" */
  src: string;
  /** Tailwind class'ları (boyut, renk için text-*). Renk currentColor olarak okunur. */
  className?: string;
}

/**
 * Tek-renk SVG'leri CSS mask olarak render eder ve `currentColor` ile renklendirir.
 *
 * Mobil bottom nav'da kullanılan /anasayfa.svg, /favoriler.svg, /ekle.svg, /profil.svg
 * gibi marka ikonlarını uygulama içinde tutarlı şekilde kullanmak için.
 *
 * Kullanım: parent'a (veya className'e) bir text rengi class'ı ekleyin
 *   <SvgMaskIcon src="/anasayfa.svg" className="text-muted-foreground h-5 w-5" />
 */
export function SvgMaskIcon({ src, className }: SvgMaskIconProps) {
  return (
    <span
      aria-hidden
      className={cn("inline-block bg-current", className)}
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
